import 'scripts/vendor/mbp-helpers';
import { setupDateFormat } from 'scripts/plugins/dateformat';
import { setupAnalytics }  from 'scripts/plugins/google-analytics';
import { Waves }           from 'scripts/vendor/waves-0.7.6-modified';

/* global MBP */

export function executePlugins( $ ) {
	
	// init dl-menu
	$( '#dl-menu' ).dlmenu();
	
	//fix iOS scaling issues
	MBP.scaleFix();
	
	//leverage screenspace - use for apps
	MBP.hideUrlBar();
	
	//undo mobile safari's disabling of :active styles
	MBP.enableActive();
	
	// init Waves (ripple effect on buttons)
	Waves.init();
	
	// setup the format function of the Date object with i18n.
	setupDateFormat();
	
	// setup the analytics snippet
	setupAnalytics();
	
	//opening view buttons call
	let channelNav = Bb.Radio.channel( 'nav' );
	
	// search
	$( '[data-click="opening-search"]' ).on( 'click', function ( event ) {
		event.preventDefault();
		channelNav.trigger( 'unit:search:serial' );
	} );
	
	// bluetooth
	$( '[data-click="opening-scan"]' ).on( 'click', function ( event ) {
		event.preventDefault();
		channelNav.trigger( 'unit:bluetooth' );
	} );
	
	// login
	$( '[data-click="opening-login"]' ).on( 'click', function ( event ) {
		event.preventDefault();
		channelNav.trigger( 'user:login' );
	} );
	
	// terms and conditions
	$( '[data-click="open-terms-and-conditions"]' ).on( 'click', function( event ) {
		event.preventDefault();
		$( '[data-click="open-terms-and-conditions"]' ).trigger( 'show:terms' );
	} );
}